// import bobtailAPI from '../axiosConfig'
import Entity from './entity'

const Plaid = new Entity('plaid')

export default Plaid
